import dataJson from "@/../public/data.json";

import "./index.less";
const prefix = "serviceSupport";

function ServiceSupport() {
  const { service_support, email_icon, phone_icon } = dataJson;

  return (
    <div className={prefix}>
      <div className={`${prefix}-banner`} style={{ backgroundImage: `url(${service_support.banner_bg_img})` }}>
        <div className={`${prefix}-title`}>{service_support.title}</div>
        <div className={`${prefix}-describe`}>
          <div>{service_support.describe}</div>
        </div>
      </div>
      <div className={`${prefix}-content`}>
        {service_support.list.map((item, index) => {
          return (
            <div key={index} className={`${prefix}-card`}>
              <div className={`${prefix}-card-title`}>{item.title}</div>
              <div className={`${prefix}-card-describe`}>{item.describe}</div>
              <div className={`${prefix}-card-email`}>
                <img src={email_icon} alt="" />
                <span className={`${prefix}-card-label`}>邮箱：</span>
                <span className={`${prefix}-card-value`}>{item.email}</span>
              </div>
              <div className={`${prefix}-card-phone`}>
                <img src={phone_icon} alt="" />
                <span className={`${prefix}-card-label`}>电话：</span>
                <span className={`${prefix}-card-value`}>{item.phone}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ServiceSupport;
